<template>
  <div class="main_page">
    <div class="head_box">
      <div class="head_left">
        <img class="logo_img" src="@/assets/image/auth/logo_white.png" alt="" />
        <span class="head_title">大象-项目系统</span>
      </div>
      <div class="head_right"></div>
    </div>
    <div class="main">
      <div class="main_inner">
        <div>
          <div class="controller">
            <img class="bg" src="@/assets/image/auth/bg.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="login_text" v-if="is_login">
      <img src="@/assets/image/auth/loading.svg" class="loading1" alt="" />
      <span class="loadin_text_span"> 登录成功，自动跳转中… </span>
    </div>
    <div v-else class="login_text">
      <Icon type="md-remove-circle" color="#ed4014" />
      <span class="loadin_text_span">
        登录超时，请点击此处
        <a class="go_login_a" @click="again_login">重新登录</a>
      </span>
    </div>
  </div>
</template>

<script>
var Base64 = require("js-base64").Base64;
const jsSHA = require("jssha");
import { http, open_new_page } from "@/utils/http.js";

export default {
  components: {},
  data() {
    return {
      current_tab: "username",
      super_admin_show: false,
      admin_login_loading: false,
      redirect_url: "",
      is_login: false,
    };
  },
  mounted() {
    // this.check_token_request();

    // var dx_token = this.$cookies.get('dx_token')
    // if (dx_token) {
    //   this.$router.push({ path: "/workbench/my_project" });
    // } else {
    //   this.again_login()
    // }
  },
  methods: {
    //检验token
    check_token_request() {
      var that = this;
      var dx_token = this.$cookies.get("dx_token");

      if (!dx_token) {
        this.again_login();
        return;
      }

      var obj = {
        token: dx_token,
        redirect_url: this.$route.query.redirect_url,
      };
      http("post", process.env.VUE_APP_HOST + "/auth/check_token", obj, true)
        .then((res) => {
          if (res.code == 0) {
            open_new_page(res.data.redirect_url, "_self");
            // if (dx_token) {
            //   if (that.isMobile()) {

            //     that.$router.push({ path: "/h5/menu" });
            //   } else {
            //     that.$router.push({ path: "/workbench/my_project" });
            //   }

            // } else {
            //   that.again_login()
            // }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
            that.again_login(res.data.redirect_url);
          }
        })
        .catch((res) => {
          that.again_login(that.$route.query.redirect_url);
          console.log(res, "请求出错");
        });
    },

    isMobile() {
      var sUserAgent = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if (
        bIsIpad ||
        bIsIphoneOs ||
        bIsMidp ||
        bIsUc7 ||
        bIsUc ||
        bIsAndroid ||
        bIsCE ||
        bIsWM
      ) {
        var mobile_flag = true;
      } else {
        var mobile_flag = false;
      }

      return mobile_flag;
    },

    again_login(redirect_url) {
      var auth_url = process.env.VUE_APP_AUTH_URL;
      // var login_url = process.env.VUE_APP_LOGIN_URL;
      var url = auth_url + "?redirect_url=" + redirect_url;
      console.log(url);
      // open_new_page(url, "_self");
    },
  },
};
</script>

<style scoped>
.go_login_a {
  color: #0466dd;
}

.loadin_text_span {
  font-size: 13px;
  color: #888;
  margin-left: 10px;
}

.loading1 {
  width: 25px;
  height: 25px;
}

.login_text {
  text-align: center;
  font-size: 16px;
  padding-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.controller {
  -webkit-animation: bounce-down 3s linear infinite;
  animation: bounce-down 3s linear infinite;
}

@-webkit-keyframes bounce-down {
  25% {
    -webkit-transform: translateY(-10px);
  }

  50%,
  100% {
    -webkit-transform: translateY(0);
  }

  75% {
    -webkit-transform: translateY(10px);
  }
}

@keyframes bounce-down {
  25% {
    transform: translateY(-10px);
  }

  50%,
  100% {
    transform: translateY(0);
  }

  75% {
    transform: translateY(10px);
  }
}

.super_admin_login {
  color: #93c2ee;
  font-size: 13px;
}

.super_admin_login:hover {
  color: #fff;
}

.head_right {
  margin-right: 50px;
}

.head_left {
  display: flex;
  align-items: center;
}

.qrcode_detail {
  margin-top: 20px;
  font-size: 12px;
  color: #777;
}

.qrcode_img {
  width: 120px;
  height: 120px;
  text-align: center;
  border: 1px solid #ccc;
}

.input {
  margin: 10px;
}

.login_input_box {
  text-align: center;
  padding: 40px 40px 40px 40px;
}

.login_tabs {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}

.main_inner {
  display: flex;
  align-items: center;
  margin: 100px 0px 0 0;
}

.logo_img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  margin-bottom: 5px;
}

.main_page {
  height: 100vh;
  background: #fcfcfc;
}

.head_title {
  cursor: pointer;
  letter-spacing: 3px;
  font-size: 18px;
  font-weight: 400;
  color: rgb(255, 255, 255);
}

.head_box {
  background: #0466dd;
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 0 40px;
}

.bg {
  height: 270px;
  width: 460px;
}

.main {
  display: flex;
  justify-content: center;
}

.login_box {
  margin-left: 150px;
  border-radius: 5px;
  width: 400px;
  height: 380px;
  background: #ffffff;
  box-shadow: 0 0 10px rgb(222, 223, 224);
}
</style>
